import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { gpedDetallesPedidoInterface } from "../interfaces/gpedDetallesPedido.inteface";

export async function CambiarEstadoPedidoAction(
    pedidoId: string,
    nombreEstado: string
): Promise<ApiResponse<gpedDetallesPedidoInterface>> {
    const { data } = await apiClient.patch(
        `gpedPedido/${pedidoId}/cambiarEstadoPedido`,
        { nombreEstado }
    );
    
    return {
        status: 200,
        data,
        message: "Estado del pedido actualizado correctamente",
    };
}